import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';
import MlmuserEditFormImpl from 'components/mlmuser/MlmuserEditFormImpl';

export default function AddUserActionImpl(){

    return (
        <>
            <Grid container spacing={2}>
                
                <Grid item xs={12}>
                    <MlmuserEditFormImpl />
                </Grid>
            </Grid>
        </>
    )
}